/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Pricing_PopularInputs */

const zh_landing_pricing_popular = /** @type {(inputs: Landing_Pricing_PopularInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`最受欢迎`)
};

const en_landing_pricing_popular = /** @type {(inputs: Landing_Pricing_PopularInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Most Popular`)
};

const es_landing_pricing_popular = /** @type {(inputs: Landing_Pricing_PopularInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Más popular`)
};

/**
* | output |
* | --- |
* | "Most Popular" |
*
* @param {Landing_Pricing_PopularInputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
export const landing_pricing_popular = /** @type {((inputs?: Landing_Pricing_PopularInputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Pricing_PopularInputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_landing_pricing_popular(inputs)
	if (locale === "en") return en_landing_pricing_popular(inputs)
	return es_landing_pricing_popular(inputs)
});